module.exports = __webpack_public_path__ + "static/project-2-3-0d0cab57e60878645a92c64f8feb10e9.jpg";